import type { ExtractPropTypes, PropType } from 'vue';
import type TextButton from './text-button.vue';

// 内置图标
export type builtInIconType = 'edit' | 'add' | 'view' | 'del' | 'download' | 'upload' | 'import' | 'export';
// 内置图标配置
export const builtInIcon: Record<builtInIconType, any> = {
  add: { icon: 'icon-xinzeng' },
  del: { icon: 'icon-shanchu', color: 'var(--el-color-danger)' },
  edit: { icon: 'icon-xiugai' },
  view: { icon: 'icon-chakan' },
  download: { icon: 'icon-xiazai11' },
  upload: { icon: 'icon-shangchuan1' },
  import: { icon: 'icon-daoru' },
  export: { icon: 'icon-daochu' },
};

export const textButtonProps = {
  // 按钮图标
  // 1、内置图标：add(新增),del(删除),edit(编辑),view(详情),download(下载),upload(上传),import(导入),export(导出)
  // 2、可使用iconfont的图标
  // 3、可使用slot.icon自定义图标
  icon: {
    type: String as PropType<builtInIconType | string>,
    default: '',
  },
  // 按钮文字颜色
  textColor: String,
  // 是否禁用
  disabled: {
    type: Boolean,
    default: false,
  },
};

export const textButtonEmits = {
  click: (evt: MouseEvent) => evt instanceof MouseEvent,
};

export type TextButtonEmits = typeof textButtonEmits;
export type TextButtonPropsType = ExtractPropTypes<typeof textButtonProps>;
export type TextButtonInstance = InstanceType<typeof TextButton>;

type TextButtonGroupItemType = TextButtonPropsType & {
  text?: string;
  slot?: string;
};
export const textButtonGroupProps = {
  group: {
    type: Array as PropType<TextButtonGroupItemType[]>,
    default: () => [],
  },
};

/**
 * 颜色加深
 * @param color
 * @param level 颜色加深程度，取值范围[0,1]
 */
export function darkenColor(color: string, level: number): string {
  // 解析颜色值
  let match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i);
  if (!match) {
    // 如果不是rgb或rgba格式，则尝试转换为16进制
    color = hexToRgb(color);
    match = color.match(/^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/i);
  }
  if (!match) {
    throw new Error('Invalid color format');
  }
  const [r, g, b, a] = match.slice(1).map((val, i) => (i === 3 ? parseFloat(val) : parseInt(val, 10)));
  // 计算加深后的颜色
  const darkenedR = Math.max(0, r - 255 * level);
  const darkenedG = Math.max(0, g - 255 * level);
  const darkenedB = Math.max(0, b - 255 * level);
  // 返回加深后的颜色
  return `rgba(${darkenedR}, ${darkenedG}, ${darkenedB}, ${a || 1})`;
}

/**
 * 获取当前Element的颜色(color)
 */
export function getElementColor(el: HTMLElement): string {
  const computedStyle = window.getComputedStyle(el);
  return computedStyle.color;
}

/**
 * 将16进制颜色转换为rgb格式
 * @param hex
 */
function hexToRgb(hex: string): string {
  hex = hex.replace(/^#/, '');
  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;
  return `rgb(${r}, ${g}, ${b})`;
}
